import { Suspense } from "react";
import Can from "../services/permisions/Can";

/* Main Layout */
const EmptyLayout = ({ children }) => children;

/*
  Private route wrapper
 */

export const EmptyLayoutRoute = ({ component: Component, permissions, ...rest }) => {
	if (!permissions) {
		return (
			<EmptyLayout>
				<Suspense fallback={null}>
					<Component {...rest} />
				</Suspense>
			</EmptyLayout>
		);
	}

	return (
		<Can I={permissions.type} a={permissions.name} withRedirect>
			<EmptyLayout>
				<Suspense fallback={null}>
					<Component {...rest} />
				</Suspense>
			</EmptyLayout>
		</Can>
	);
};
